import React, { useContext } from 'react';
import { Context } from 'components/Store';
import GrowUIFormField from 'components/Forms/GrowUIFormField';
import { Input } from '@agconnections/grow-ui';

const PumpLift = () => {
  const [{ isEnableInfoTabEdit }] = useContext(Context);
  return (
    <GrowUIFormField
      control={Input}
      id="pumpLift"
      name="pumpLift"
      label="Pump Lift"
      disabled={!isEnableInfoTabEdit}
      placeholder="Enter pump lift"
    />
  );
};

export default PumpLift;
